import { createContext, useState } from "react";

export const ProcessStatusForeignContext = createContext({});

export const Provider = (props) => {
    const { children } = props;

    const [processStatusForeigns, setProcessStatusForeigns] = useState([]);

    // Make the context object:
    const processStatusForeignContext = {
        processStatusForeigns,
        setProcessStatusForeigns,
    };

    // pass the value in provider and return
    return <ProcessStatusForeignContext.Provider value={processStatusForeignContext}>{children}</ProcessStatusForeignContext.Provider>;
};

export const { Consumer } = ProcessStatusForeignContext;
